<template lang="html">
  <div style="padding:30px;text-align:center;">
    请点击右上角，并选择在浏览器中打开。
  </div>
</template>

<script>
export default {
  data() {
    return {
      androidUrl: 'https://www.pgyer.com/LOCh',
      iosUrl: 'https://itunes.apple.com/cn/app/妥私募/id1332550394?mt=8',
    };
  },
  created() {
    const u = navigator.userAgent;
    // android终端
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
    // ios终端
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isAndroid) {
      window.location.href = this.androidUrl;
    } else if (isiOS) {
      window.location.href = this.iosUrl;
    } else {
      this.$createDialog({
        type: 'alert',
        title: '提示',
        content: '未检测到设备信息',
      }).show();
    }
  },
};
</script>
